import { parseClock, formatClock } from './fam-sleep-calculator.js';

if (!customElements.get('fam-wind-down')) customElements.define('fam-wind-down', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.steps = [...this.querySelectorAll('[data-wind-step]')];
    if (!this.steps.length) return;
    const options = { signal: this.controller.signal };
    this.querySelector('[data-wind-start]').addEventListener('click', event => { event.preventDefault(); this.show(0); }, options);
    this.querySelector('[data-wind-next]').addEventListener('click', () => this.show(this.index + 1), options);
    this.querySelector('[data-wind-previous]').addEventListener('click', () => this.show(this.index - 1), options);
    this.querySelector('[data-wind-all]').addEventListener('click', () => this.showAll(), options);
    this.querySelector('[data-wind-restart]').addEventListener('click', () => this.showAll(), options);
    this.restoreSchedule();
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  restoreSchedule() {
    if (!location.hash.startsWith('#wind=')) return;
    const data = new URLSearchParams(location.hash.slice(6));
    let bed;
    try { bed = parseClock(data.get('bed')); } catch { return; }
    const minutes = Number(data.get('minutes')), format = data.get('format');
    if (!data.has('minutes') || !Number.isInteger(minutes) || minutes < 0 || minutes > 120 || minutes % 5 || !['12', '24'].includes(format)) return;
    this.querySelector('[data-wind-schedule]').textContent = minutes === 0
      ? `Your planned bedtime is ${formatClock(bed, format)}. No wind-down time was reserved; use any steps that fit without delaying sleep.`
      : `Start at ${formatClock(bed - minutes, format)}${bed - minutes < 0 ? ' the previous day' : ''}, with bedtime at ${formatClock(bed, format)}. You reserved ${minutes} minutes; shorten or skip steps to fit.`;
  }
  show(index) {
    this.index = Math.max(0, Math.min(index, this.steps.length));
    const done = this.index === this.steps.length;
    this.steps.forEach((step, position) => { step.hidden = done || position !== this.index; });
    this.querySelector('[data-wind-toolbar]').hidden = false;
    this.querySelector('[data-wind-controls]').hidden = done;
    this.querySelector('[data-wind-done]').hidden = !done;
    this.querySelector('[data-wind-start]').hidden = true;
    this.querySelector('[data-wind-progress]').textContent = done ? 'Plan complete' : `Step ${this.index + 1} of ${this.steps.length}`;
    this.querySelector('[data-wind-previous]').disabled = this.index === 0;
    this.querySelector('[data-wind-next]').textContent = this.index === this.steps.length - 1 ? 'Finish the plan' : 'Next step';
    const target = done ? this.querySelector('[data-wind-done]') : this.steps[this.index].querySelector('[data-wind-heading]');
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
  }
  showAll() {
    this.steps.forEach(step => { step.hidden = false; });
    this.querySelector('[data-wind-toolbar]').hidden = true;
    this.querySelector('[data-wind-controls]').hidden = true;
    this.querySelector('[data-wind-done]').hidden = true;
    this.querySelector('[data-wind-start]').hidden = false;
    this.querySelector('[data-wind-start]').focus();
  }
});
